import $ from 'jquery';

$(function () {
    $('.expandingform .expand-form').on('click', function (evt) {
        evt.preventDefault();
        let id = $(this).data('form');
        let $me = $(this).parent('div');

        $('#' + id).removeClass('hide');
        $me.addClass('hide');
    });

    $('.expandingform .close').on('click', function (evt) {
        evt.preventDefault();
        let panel = $(this).data('panel');
        let $me = $(this).parent().parent('div');

        $('#' + panel).removeClass('hide');
        $me.addClass('hide');
    });
});